import React, { useEffect, useRef } from "react";

// Reproduce el video solo mientras está visible en el viewport (feeds con
// scroll infinito): evita que todos los videos de la lista suenen/consuman
// recursos a la vez, y lo pausa apenas el usuario sigue scrolleando.
const ScrollAwareVideo = ({ threshold = 0.6, ...videoProps }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, [threshold]);

  return <video ref={videoRef} {...videoProps} />;
};

export default ScrollAwareVideo;
